import React from "react";
import "../../css/BUVideos.css";

const videosData = [
  { title: "Success Began 20 Years Ago | Benadir University", url: "https://www.youtube.com/embed/ClX_810xKX8" },
  { title: "Qeylodhaan, Qaylodhaan", url: "https://www.youtube.com/embed/1SYnOhU8Npk" },
  { title: "Gud. J. Benadir Prof. Dr. Mohamed M. (Biday) oo qaraxii hotel shamoow uga warbixiyay ‪", url: "https://www.youtube.com/embed/ZN5_veDumUY" },
  { title: "THIS IS SOMALIA! | A Rich Heritage & A Bright Future | SOMALI ENTERPRISE.", url: "https://www.youtube.com/embed/dI_lNFMpgzQ" },
  { title: "Horumarka SMA & isbeddelka", url: "https://www.youtube.com/embed/6ePTo_tLIFc" },
  { title: "Jaamacadda Benadir waxay hormuud u tahay waxbarashada ku saleysan (Experiential Learning).", url: "https://www.youtube.com/embed/s_woIES8WEg" },
  { title: "Jaamacadda Benadir oo u dirtay 7 arday dalka Turkiga", url: "https://www.youtube.com/embed/3tkG7nBzRdg" },
];

const BUVideos = () => {
  return (
    <section id="videos" className="bu-videos">
      <h2>BU Videos</h2>
      <div className="videos-container">
        {videosData.map((video, index) => (
          <div className="video-box" key={index}>
            <iframe
              width="100%"
              height="250"
              src={video.url}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <h4>{video.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BUVideos;
